var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"interval":4000,"height":"544px"}},_vm._l((6),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticClass:"banner-img",attrs:{"src":_vm.$data[`PIC000${item}`],"alt":""}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }